module.exports = __webpack_public_path__ + "static/media/quest20-lock.7f4be0d2.png";